import './pages/router';
import './searchPlan'

export ProgressState from './components/ProgressState/ProgressState';
export PullRefresh from './components/PullRefresh/PullRefresh';
export DateRange from './components/DateRange';
export DatePick from './components/DatePick';
export InputItem from './components/InputItem';
export InputRage from './components/InputRage';
export CheckButton from './components/CheckButton';
export CheckSwitchButton from './components/CheckSwitchButton';
export RefBox from './components/RefBox'; // 参照
export RefBoxForReportForms from './components/RefBoxForReportForms'; // 参照
export RefPage from './components/RefPage'; // 参照选择界面
export RefTree from './components/RefTree'; // 参照选择界面
export SearchBar from './components/SearchBar';
export Ticon from './components/Icon';
export TransitionGroup from './components/TransitionGroup';
export Element from './components/Element';
export ButtonGroup from './components/ButtonGroup';
export ModalPage from './components/ModalPage';
export CheckBox from './components/CheckBox';
export DateRangeOnlyModal from './components/DateRangeOnlyModal';
export RefStore from './components/RefPage/store';
export SearchRemote from './components/SearchRemote'


// export RefInventory from './pages/inventory';
export RefPartner from './pages/partner';

// export InventoryList from './pages/inventory/inventoryList'; // 对上述组件的汇总
// export SearchPageView from './pages/view/SearchPageView'; // 报表方案查询界面
// export RefPageViews from './pages/view/RefPageView'; // 参照选择界面


//page
export FilterView from './pages/view/FilterView/filterPage';


export VTextControl from './voucherComponents/TextControl';
export VTextControlWithBorder from './voucherComponents/TextControlWithBorder';
export VActionControl from './voucherComponents/ActionControl';
export VCheckControl from './voucherComponents/CheckControl';
export VComboBox from './voucherComponents/ComboBox';
export VDateControl from './voucherComponents/DateControl';
export VDropdown from './voucherComponents/Dropdown';
export VDropdownAndExplain from './voucherComponents/DropdownAndExplain';
export VToggleControl from './voucherComponents/ToggleControl';
export VTimePickerControl from './voucherComponents/TimePickerControl';

